/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {
  formatDate,
  formatTimeString,
  getNewDate,
  hideHeaderFooter,
  showHeaderFooter,
} from '../../shared/helper-utils/appUtils';
import {
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  getFlightCancellationDetailsApi,
  getFlightInvoiceDetailsApi,
} from '../../api/flightApi';
import { getUserDetails } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import NumberToWords from '../../shared/components/NumberToWords';
import {
  DATE_MONTH_YEAR_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { APP_LOGO_URL } from '../../saas/AppStorageStaticNames';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../shared/constants/FlightCarrierNames';

function FlightRefundReceipt() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [hasInvoice, setHasInvoice] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [agent, setAgent] = useState({});
  const flightCancellationRef = useRef({});
  const flightInvoiceRef = useRef({});
  const passengerRef = useRef([]);
  const fareSummaryRef = useRef(undefined);
  const flightSectorsRef = useRef({});

  const getFlightCancellationDetails = async () => {
    setIsLoading(true);
    try {
      const detailRes = await getUserDetails(getUserAgentId());
      if (detailRes.ApiStatus?.Status === 'OK') {
        const user = detailRes.ApiStatus.Result.User;
        setAgent(user);
      }
      const response = await getFlightCancellationDetailsApi(
        transactionId,
        getUserAgentId(),
      );
      if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status === 'OK'
      ) {
        const { flightcancellation, flightcanxpax } = response.ApiStatus.Result;
        flightCancellationRef.current = flightcancellation;
        const res = await getFlightInvoiceDetailsApi(
          flightCancellationRef.current.reference_txid,
          getUserAgentId(),
        );
        fareSummaryRef.current = {
          baseFare: flightcancellation.basefare,
          commission: flightcancellation.commission,
          tds: flightcancellation.tds,
          airlineTax: flightcancellation.tax,
          addonCharge: flightcancellation.ssr_amount,
          reversalAmount: flightcancellation.handlingcharges,
          canxCharge: flightcancellation.airline_canx_charge,
          otaCanxCharge: flightcancellation.canx_charge,
          refundAmount: flightcancellation.refund_amount,
        };
        fareSummaryRef.current.refundToAirline =
          flightcancellation.basefare +
          flightcancellation.ssr_amount +
          flightcancellation.tax -
          flightcancellation.airline_canx_charge;
        fareSummaryRef.current.totalRefund =
          fareSummaryRef.current.refundToAirline +
          flightcancellation.handlingcharges +
          flightcancellation.tds -
          flightcancellation.commission;
        let Sgst = 0;
        let Cgst = 0;
        let Igst = 0;
        if (flightcancellation.gst_type === 'SGSTCGST') {
          Sgst = flightcancellation.servicetax / 2;
          Cgst = flightcancellation.servicetax / 2;
        } else {
          Igst = flightcancellation.servicetax;
        }
        fareSummaryRef.current.sgst = Sgst;
        fareSummaryRef.current.cgst = Cgst;
        fareSummaryRef.current.igst = Igst;
        if (flightcanxpax && flightcanxpax !== '') {
          const list = Array.isArray(flightcanxpax)
            ? flightcanxpax
            : [flightcanxpax];
          passengerRef.current = list;
        }
        if (res) {
          const { FlightInvoice } = res;
          flightInvoiceRef.current = FlightInvoice;
          let { FlightTicket } = FlightInvoice.FlightTickets;
          FlightTicket = Array.isArray(FlightTicket)
            ? FlightTicket
            : [FlightTicket];
          let { SectorRecord } = FlightInvoice.SectorRecords;
          SectorRecord = Array.isArray(SectorRecord)
            ? SectorRecord
            : [SectorRecord];
          flightSectorsRef.current = SectorRecord;
          passengerRef.current.forEach((pax) => {
            const ticket = FlightTicket.find(
              (record) => record.Paxid === pax.PaxId,
            );
            if (ticket) {
              pax.pnrNumber = ticket.AirlinePnr;
              pax.ticketNumber = ticket.TicketNumber;
            }
          });
          setHasInvoice(true);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setAlert({
        variant: 'error',
        title: 'Flight Refund Receipt',
        description: 'Failed to fetch Details',
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFlightCancellationDetails();
  }, [transactionId]);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);
  return (
    <div>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="print-links d-flex flex-column hide-in-print">
        <a onClick={() => window.print()}>
          <img src="/images/others/print_sidebutton.png" alt="" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING}>
          <img src="/images/others/home_sidebutton.png" alt="" />
        </a>
      </div>
      {hasInvoice && (
        <div
          style={{
            padding: '1rem 10px',
            width: '900px',
            marginInline: 'auto',
            backgroundColor: '#fff',
          }}
          id="ticketheader"
        >
          <div style={{ border: '1px solid #000' }}>
            <div
              style={{
                padding: '10px',
                fontWeight: '600',
                borderBottom: '1px solid #000',
              }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="flex-1">
                <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt={appConfig?.companyName}
                  width="80px"
                />
              </div>
              <div className="flex-1 text-start">Refund Receipt</div>
            </div>
            <div
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                fontWeight: '300',
              }}
              className="d-flex flex-column"
            >
              {getValueFromAppConfig('INVADDRESS')
                .split('<br>')
                .map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
            </div>
            {Object.keys(agent).length > 0 && (
              <div
                className="py-1 fs-12 d-flex px-2"
                style={{ border: '1px solid #000' }}
              >
                <div className="d-flex flex-column flex-1 gap-1">
                  <span>
                    <b>To M/s:</b> {agent.Company}
                    <br />
                  </span>
                  <span>
                    <b>Address: </b>
                    {agent.Address1},{agent.Address2},{agent.City},{agent.State}
                    ,{agent.PinCode},
                    <br />
                  </span>
                  <span>
                    <b>Email: </b>
                    {agent.ContactEmail}
                    <br />
                  </span>
                  <span>
                    <b>Phone: </b>
                    {agent.ContactNumber}
                    <br />
                  </span>
                  <span>
                    <b>GSTN No: </b> {agent.Gst_number}
                  </span>
                </div>
                <div className="d-flex justify-content-between flex-1">
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>AgentId: </b> {agent.AgentId}
                    </span>
                    <span>
                      <b>Invoice Date: </b>{' '}
                      {flightCancellationRef.current.tx_date.split(' ')[0] &&
                        formatDate(
                          getNewDate(
                            flightCancellationRef.current.tx_date.split(' ')[0],
                          ),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Invoice No: </b>{' '}
                      {flightCancellationRef.current.booking_invoicenumber}
                    </span>
                    <span>
                      <b>HSN/SAC: </b> 998551
                    </span>
                    <span>
                      <b>Reference ID: </b>{' '}
                      {flightCancellationRef.current.reference_txid}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>Credit Note Date: </b>{' '}
                      {flightCancellationRef.current.refunddate.split(' ')[0] &&
                        formatDate(
                          getNewDate(
                            flightCancellationRef.current.refunddate.split(
                              ' ',
                            )[0],
                          ),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Credit Note No: </b> {transactionId}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center p-1 fs-12 fw-500">
              Category Type : Flight
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12  w-100 ">
                <thead>
                  <tr className="text-center">
                    <th>Sector(s) & Flight Details</th>
                  </tr>
                </thead>
                <tbody>
                  {flightSectorsRef.current.map((sector) => (
                    <tr
                      key={`${sector.Origin}_${sector.Destination}_${sector.TripNumber}`}
                    >
                      <td>
                        {`${sector.Origin} - ${sector.Destination} | ${
                          AIRLINE_NAMES_FOR_CARRIER_CODE[
                            sector.Carrier.substring(0, 2)
                          ]
                        } (${sector.Carrier.substring(0, 2)} ${
                          sector.FlightNumber
                        }) |`}
                        {` Departure Time : ${formatTimeString(
                          sector.DepartureTime,
                        )},`}{' '}
                        {formatDate(
                          getNewDate(sector.JourneyDate),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr className="text-center">
                    <th colSpan="3">Passenger details</th>
                  </tr>
                  <tr>
                    <th>Passenger Name</th>
                    <th>Ticket Number</th>
                    <th>PNR Number</th>
                  </tr>
                </thead>
                <tbody>
                  {passengerRef.current.map((pax, index) => (
                    <tr key={index}>
                      <td
                        style={{ textTransform: 'uppercase' }}
                      >{`${pax.paxtitle} ${pax.paxfname} ${pax.paxlname}`}</td>
                      <td>{pax.ticketNumber}</td>
                      <td>{pax.pnrNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="fs-12 d-flex justify-content-between gap-1 px-2 border-bottom pb-2">
              <div className="d-flex align-items-end">
                <p className="mb-0">
                  <b>Amount in Words : </b>
                  <span className="text-capitalize fw-300">
                    <NumberToWords
                      number={fareSummaryRef.current.refundAmount.toFixed(2)}
                    />
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-end">
                <table>
                  <tbody>
                    <tr>
                      <td>[ + ] Basic</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.baseFare.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Airline Taxes</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.airlineTax.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Addons</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.addonCharge.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] Cancellation charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.canxCharge.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] Service Charge </td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.reversalAmount.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] OTA Canx Charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.otaCanxCharge.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] SGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.sgst.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] CGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.cgst.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] IGST @ 18%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.igst.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] commission</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.commission.toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-bottom">
                      <td>[ - ] TDS</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.tds.toFixed(2)}
                      </td>
                    </tr>
                    <tr className="fw-bold border-bottom">
                      <td> Total Refund Amount (Rs)</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {fareSummaryRef.current.refundAmount.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-2 fs-12 fw-600">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1 flex-column flex-1">
                  <span>
                    <b>Terms & Conditions: </b>
                  </span>
                  <ul>
                    <li>
                      This is computer generated invoice signature not required.
                    </li>

                    <li>
                      Refunds Cancellations are subject to Supplier&apos;s
                      approval
                    </li>
                    <li>
                      Kindly check all details carefully to avoid unnecessary
                      complications.
                    </li>
                    <li>
                      CHEQUE : Must be drawn in favour of &quot;:{' '}
                      {appConfig?.companyName} &quot;
                    </li>
                    <li>
                      LATE PAYMENT : Interest @ 24% per annum will be charged on
                      all outstanding bills after the due date.
                    </li>
                    <li>
                      All transactions between the Company and the Agency are
                      subject to the Company&apos;s Privacy Policy and Terms and
                      Conditions
                    </li>
                    <li>
                      All invoices and credit notes are confidential and should
                      not be disclosed to third parties without prior written
                      consent from the Company.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-center mb-3">
                  <p>{getValueFromAppConfig('COMPANYNAME')}</p>
                  <span>Authorised Signature</span>
                </div>
              </div>
              <div
                style={{
                  marginTop: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                {getValueFromAppConfig('bankdetailshtml')}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FlightRefundReceipt;
